import { AbstractControl } from '@angular/forms';

export function validatePassword(c: AbstractControl) {
    let LOWERCASE_REGEX = /[a-z]+/;
    let UPPERCASE_REGEX = /[A-Z]+/;
    let NUMBER_REGEX = /\d+/;
    let WHITESPACE_REGEX = /\s/;

    // If the value of the control tests against the regex, there is no error (return null).
    if (c.value == null || c.value == '' || c.value.length < 8) {
        return null;
    }

    //if have whitespace, fail it
    if (WHITESPACE_REGEX.test(c.value)) {
        return {
            validatePassword: {
                valid: false,
            },
        };
    }

    //if have at least 1 lowercase, 1 uppercase, and 1 number, return success, else, fail it
    if (LOWERCASE_REGEX.test(c.value)) {
        if (UPPERCASE_REGEX.test(c.value)) {
            if (NUMBER_REGEX.test(c.value)) {
                return null;
            }
        }
    }

    return {
        validatePassword: {
            valid: false,
        },
    };
}
